module.exports = __webpack_public_path__ + "media/images/home/crm-dadd5a8853c40706f3711f58f9351c0f.png";